import axios from 'axios'

let api = axios.create()

export const loadConfig = async () => {
  try {
    const response = await fetch('/config.json')
    if (!response.ok) {
      throw new Error('Erro ao carregar config.json')
    }
    const config = await response.json()

    const baseURL = config.api.baseUrl

    // Inicialize Axios com o baseURL do JSON
    api.defaults.baseURL = baseURL

    return config
  } catch (error) {
    console.error('Erro ao carregar a configuração:', error)
    throw error
  }
}

// Configura os interceptors
export const setInterceptors = (authToken) => {
  if (!api) {
    throw new Error(
      'Configuração ainda não foi carregada. Certifique-se de chamar loadConfig primeiro.'
    )
  }

  api.interceptors.request.use(async (config) => {
    if (!config.headers.Authorization) {
      config.headers.Authorization = `${authToken}`
      config.headers['Cache-Control'] = 'no-cache'
      config.headers.Pragma = 'no-cache'
      config.headers.Expires = '0'
    }
    return config
  })
}

// Exporte as instâncias Axios
export { api }
